<template>
  <div class="legal-page">
    <header class="legal-header">
      <div class="header-container">
        <router-link to="/" class="logo-link">
          <img src="/landing/logo-white.svg" alt="Макетта" class="logo" />
        </router-link>
        <router-link to="/" class="back-link">← На главную</router-link>
      </div>
    </header>

    <main class="legal-content">
      <h1>Согласие на обработку персональных данных пользователя сайта</h1>

      <section class="legal-section consent-block">
        <p>Я, Пользователь сайта https://maketta.pro/ (далее – Сайт) настоящим даю согласие ИП Немыкиной Екатерине Сергеевне (ИНН 421717178949, далее — Оператор) на обработку моих персональных данных на следующих условиях, а также на условиях, указанных в Политике обработки персональных данных Оператора, размещенной в сети Интернет по адресу https://maketta.pro/</p>

        <div class="consent-table">
          <div class="consent-row">
            <span class="consent-label">Категории обрабатываемых персональных данных</span>
            <span class="consent-value">общие.</span>
          </div>
          <div class="consent-row">
            <span class="consent-label">Перечень обрабатываемых персональных данных</span>
            <span class="consent-value">фамилия, имя; отчество (в объеме, указанном Пользователем), адрес электронной почты; номер телефона.</span>
          </div>
          <div class="consent-row">
            <span class="consent-label">Цель обработки персональных данных</span>
            <span class="consent-value">заключение, исполнение и прекращение гражданско-правовых договоров (приобретение Пользователем услуг Оператора).</span>
          </div>
          <div class="consent-row">
            <span class="consent-label">Способ обработки персональных данных</span>
            <span class="consent-value">смешанная автоматизированная и неавтоматизированная обработка персональных данных.</span>
          </div>
          <div class="consent-row">
            <span class="consent-label">Действия с персональными данными в ходе их обработки</span>
            <span class="consent-value">сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передача, блокирование, удаление, уничтожение.</span>
          </div>
          <div class="consent-row">
            <span class="consent-label">Срок действия согласия</span>
            <span class="consent-value">с даты предоставления персональных данных Пользователями с их согласия (в применимых случаях) и в течение 3 лет с даты исполнения Сторонами обязательств по заключенному договору (при условии его заключения, с учетом срока исковой давности по требованиям об исполнении договоров), или до достижения цели обработки персональных данных, или до момента отзыва Пользователем своего согласия на обработку персональных данных/получения Оператором требования о прекращении обработки персональных данных, если иной срок не предусмотрен договором или действующим законодательством.</span>
          </div>
          <div class="consent-row">
            <span class="consent-label">Отзыв согласия</span>
            <span class="consent-value">согласие может быть отозвано Пользователем в любой момент путем направления Оператору письменного заявления Пользователя на адрес электронной почты оператора maketta.pro@mail.ru. Заявление Пользователя должно содержать указание на фамилию и имя заявителя и указание на отзыв согласия на обработку персональных данных, предоставленных Оператору. Оператор вправе продолжить обработку персональных данных при наличии оснований, предусмотренных Законом о персональных данных.</span>
          </div>
        </div>
      </section>

      <section class="legal-section">
        <p>Пользователь подтверждает, что ознакомлен с <router-link to="/privacy-policy">Политикой в отношении обработки персональных данных</router-link> и даёт согласие на обработку своих персональных данных на указанных условиях.</p>
      </section>
    </main>

    <footer class="legal-footer">
      <p>© 2025 — {{ currentYear }} Макетта. Все права защищены.</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'PersonalDataConsent',
  data() {
    return { currentYear: new Date().getFullYear() }
  }
}
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  background: #f8f9fa;
}

.legal-header {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  padding: 20px 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  height: 36px;
  width: 99px;
  object-fit: contain;
}

.back-link {
  color: #fff;
  text-decoration: none;
  font-weight: 500;
  opacity: 0.9;
  transition: opacity 0.2s;
}

.back-link:hover {
  opacity: 1;
}

.legal-content {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  background: #fff;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

h1 {
  font-size: 28px;
  color: #1a1a2e;
  margin-bottom: 30px;
  line-height: 1.3;
}

.legal-section {
  margin-bottom: 25px;
}

.legal-section p {
  color: #444;
  line-height: 1.7;
  margin-bottom: 20px;
}

.legal-section a {
  color: #6366f1;
  text-decoration: underline;
}

.consent-table {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 20px;
}

.consent-row {
  display: flex;
  border-bottom: 1px solid #eee;
}

.consent-row:last-child {
  border-bottom: none;
}

.consent-label {
  width: 260px;
  flex-shrink: 0;
  background: #f8f9fa;
  padding: 14px 16px;
  font-weight: 600;
  font-size: 13px;
  color: #555;
  border-right: 1px solid #eee;
  line-height: 1.5;
}

.consent-value {
  padding: 14px 16px;
  color: #444;
  font-size: 14px;
  line-height: 1.7;
  flex: 1;
}

.legal-footer {
  text-align: center;
  padding: 30px;
  color: #666;
}

@media (max-width: 768px) {
  h1 {
    font-size: 22px;
  }

  .legal-content {
    padding: 20px 15px;
  }

  .consent-row {
    flex-direction: column;
  }

  .consent-label {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #eee;
  }
}
</style>
